var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env != 'prod')?_c('b-taglist',{staticClass:"environment",attrs:{"attached":""}},[_c('b-tag',{attrs:{"type":"is-danger"}},[_vm._v(_vm._s(_vm.env))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }